import React from 'react';
import PropTypes from 'prop-types';
import {arc} from 'd3-shape';

class RadialIndicator extends React.Component {
    static defaultProps = {
        outerCircleClasses: '',
        innerCircleClasses: '',
        textClasses: '',
        pathClasses: '',
        fillPercentsAndColors: [],
        fillerText: '',
        innerFill: '',
        outerFill: '',
    }

    static propTypes = {
        innerWidthFunctionOfWidth: PropTypes.func.isRequired,
        containerId: PropTypes.string.isRequired,
        outerCircleClasses: PropTypes.string.isRequired,
        innerCircleClasses: PropTypes.string.isRequired,
        textClasses: PropTypes.string.isRequired,
        pathClasses: PropTypes.string.isRequired,
        fillPercentsAndColors: PropTypes.arrayOf(
            PropTypes.shape({
                color: PropTypes.string,
                fillPercent: PropTypes.number
            })
        ).isRequired,
        innerFill: PropTypes.string.isRequired,
        outerFill: PropTypes.string.isRequired,
        fillerText: PropTypes.string,
    }

    state = {
        width: 0,
    }

    handleResize = () => {
        const {
            containerId,
        } = this.props;
        let container = document.getElementById(containerId);
        const that = this;

        setTimeout(function() {
            if (container) {
                let containerWidth = container.clientWidth;
                that.setState({
                    width: containerWidth,
                });
            }
        }, 350);
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }


    render() {
        const {
            outerFill,
            innerFill,
            innerWidthFunctionOfWidth,
            fillPercentsAndColors,
            fillerText,
            innerCircleClasses,
            outerCircleClasses,
            pathClasses,
            textClasses,
            containerId,
        } = this.props;

        let fillPercentUsed = 0;
        let that = this;
        let paths = fillPercentsAndColors.map(function(fillPercentAndColor, i) {
            let _startAngle = fillPercentUsed * (2*Math.PI) / 100;
            let fillPercent = Number(fillPercentAndColor.fillPercent);
            let _arcAngle = fillPercent * (2*Math.PI) / 100;
            fillPercentUsed += fillPercent;
            let d = (arc())({
                innerRadius: 0,
                outerRadius: that.state.width / 2,
                startAngle: _startAngle,
                endAngle: _startAngle + _arcAngle,
            });

            return (
                <path className={ pathClasses } key={i} d={d} style={{fill: fillPercentAndColor.color}} />
            );
        });

        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                }}
                id={containerId}
            >
                <svg
                    width={this.state.width}
                    height={this.state.width}
                >
                    <g
                        transform={ 'translate(' + this.state.width / 2 + ',' + this.state.width / 2 + ')' }
                    >
                        <circle
                            className={ outerCircleClasses }
                            r={ this.state.width / 2}
                            fill={outerFill}
                        />
                            {paths}
                        <circle
                            className={ innerCircleClasses }
                            r={ innerWidthFunctionOfWidth(this.state.width) / 2 }
                            fill={innerFill}
                        />
                        <text
                            className={ textClasses }
                            y={'.33em'}
                            textAnchor={'middle'}
                            fontWeight={'bold'}
                        >
                            {fillerText}
                        </text>
                    </g>
                </svg>
            </div>
        );
    }
};

export default RadialIndicator;
